export default __webpack_public_path__ + "static/media/headshot-pardip-rai.030b8e59.jpeg";